import { render } from "./LeaveRemaining.vue?vue&type=template&id=7ad24370&scoped=true"
import script from "./LeaveRemaining.vue?vue&type=script&lang=js"
export * from "./LeaveRemaining.vue?vue&type=script&lang=js"

import "./LeaveRemaining.vue?vue&type=style&index=0&id=7ad24370&lang=scss&scoped=true"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad24370"]])

export default __exports__